import { CarouselFeature } from "./feature-base.js";
class ScrollbarHandlerFeature extends CarouselFeature {
  constructor(host, scrollbar) {
    super(host);
    this.scrollBarUpdateCallback = ({
      scrollWidth,
      scrollLeft,
      clientWidth
    }) => {
      const { scrollbar } = this;
      if (scrollWidth) {
        scrollbar.style.setProperty(
          "--skapaScrollHandleLeft",
          `${(100 * Math.abs(scrollLeft) / scrollWidth).toFixed(2)}%`
        );
        scrollbar.style.setProperty(
          "--skapaScrollHandleWidth",
          `${(100 * clientWidth / scrollWidth).toFixed(2)}%`
        );
      }
      scrollbar.classList.toggle("hide", clientWidth >= scrollWidth);
    };
    this.handleScrollbarEvents = (ev) => {
      const { features, scrollContainer } = this.host;
      const { scroller } = features.scroller;
      if (ev.type === "skapa-scrollbar-scroll") {
        const rawScrollTarget = (this.host.features.writingDirection.isRTL ? -1 : 1) * ev.detail.dragPos * scrollContainer.scrollWidth;
        scroller.scrollLeft = scroller.instant ? rawScrollTarget : this.host.features.scroller.getNearestSnapTarget(rawScrollTarget);
      } else if (ev.type === "skapa-scrollbar-scroll-start") {
        scroller.instant = true;
        scroller.inertia = 0;
      } else {
        scroller.instant = false;
        const speed = ev.detail;
        const inertiaScrollingOffset = 0.3 * speed * this.host.scrollContainer.scrollWidth;
        scroller.inertia = Math.abs(speed * 5);
        this.micro(() => {
          scroller.scrollLeft = this.host.features.scroller.getNearestSnapTarget(
            scroller.scrollLeft + inertiaScrollingOffset
          );
        }, "set scroll inertia target");
      }
    };
    this.scrollbar = scrollbar;
    host.gatherProperties(["hiddenScrollbar"], host);
    Object.defineProperty(host, "hiddenScrollbar", {
      get() {
        return host.hasAttribute("hidden-scrollbar");
      },
      set(val) {
        host.toggleAttribute("hidden-scrollbar", !!val);
      }
    });
  }
  connectedCallback() {
    this.scrollbar.addEventListener(
      "skapa-scrollbar-scroll",
      this.handleScrollbarEvents
    );
    this.scrollbar.addEventListener(
      "skapa-scrollbar-scroll-start",
      this.handleScrollbarEvents
    );
    this.scrollbar.addEventListener(
      "skapa-scrollbar-scroll-end",
      this.handleScrollbarEvents
    );
    this.host.features.scroller.addEventListener(
      "SKAPA_CAROUSEL_SCROLL_UPDATE",
      this.scrollBarUpdateCallback
    );
  }
  disconnectedCallback() {
    this.scrollbar.removeEventListener(
      "skapa-scrollbar-scroll",
      this.handleScrollbarEvents
    );
    this.scrollbar.removeEventListener(
      "skapa-scrollbar-scroll-start",
      this.handleScrollbarEvents
    );
    this.scrollbar.removeEventListener(
      "skapa-scrollbar-scroll-end",
      this.handleScrollbarEvents
    );
    this.host.features.scroller.removeEventListener(
      "SKAPA_CAROUSEL_SCROLL_UPDATE",
      this.scrollBarUpdateCallback
    );
  }
}
export {
  ScrollbarHandlerFeature
};
